const SidebarFloating = () => (
  <>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M4 7a2.5 2.5 0 0 1 2.5-2.5h3a2.5 2.5 0 0 1 2.45 2h5.55A2.5 2.5 0 0 1 20 9v6a2.5 2.5 0 0 1-2.5 2.5h-5.55a2.5 2.5 0 0 1-2.45 2h-3A2.5 2.5 0 0 1 4 17zm8 9.5h5.5A1.5 1.5 0 0 0 19 15V9a1.5 1.5 0 0 0-1.5-1.5H12zm-5.5-11A1.5 1.5 0 0 0 5 7v10a1.5 1.5 0 0 0 1.5 1.5h3A1.5 1.5 0 0 0 11 17V7a1.5 1.5 0 0 0-1.5-1.5z"
      clipRule="evenodd"
    />
  </>
)
export default SidebarFloating
